import { gql } from 'graphql.macro';

export const apiClientFieldsFragment = gql`
    fragment apiClientFields on ApiClient {
        _id
        organization
        name
        clientId
        mode
        scopes
        disabled
        lastUsedAt
        secretLastRotatedAt
        createdBy
        createdAt
        updatedAt
    }
`;
